import { useState } from 'react'
import { Tabs, Tag, Typography } from 'antd'
import { IdcardOutlined, LockOutlined, SafetyOutlined, TableOutlined } from '@ant-design/icons'
import '../../../styles/aurora-page.css'
import '../../../styles/aurora-modal.css'
import FakeDataTab from './FakeDataTab'
import BatchDataTab from './BatchDataTab'
import MaskDataTab from './MaskDataTab'
import CryptoTab from './CryptoTab'

const { Title } = Typography

/** 数据构造主页面：内置虚拟数据生成/批量参数化造数/数据脱敏/编码与加解密四个页签模块 */
export default function DataFactory() {
  const [activeKey, setActiveKey] = useState('fake')

  return (
    <div className="aurora-page aurora-page--fit">
      {/* ① 页头 */}
      <div className="page-header">
        <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
          <Title level={4} style={{ margin: 0, fontWeight: 600 }}>数据构造</Title>
          <Tag color="warning" style={{ borderRadius: 999 }}>所有生成数据仅供测试使用，禁止用于任何真实场景</Tag>
        </div>
      </div>

      {/* ② 主内容卡片：四页签内嵌（与「抓包」页结构统一） */}
      <div className="content-card">
        <Tabs
          activeKey={activeKey}
          onChange={setActiveKey}
          tabBarStyle={{ paddingLeft: 22 }}
          items={[
            {
              key: 'fake',
              label: (
                <span><IdcardOutlined /> 虚拟数据生成</span>
              ),
              children: <FakeDataTab />,
            },
            {
              key: 'batch',
              label: (
                <span><TableOutlined /> 批量参数化造数</span>
              ),
              children: <BatchDataTab />,
            },
            {
              key: 'mask',
              label: (
                <span><SafetyOutlined /> 数据脱敏</span>
              ),
              children: <MaskDataTab />,
            },
            {
              key: 'crypto',
              label: (
                <span><LockOutlined /> 编码与加解密</span>
              ),
              children: <CryptoTab />,
            },
          ]}
        />
      </div>
    </div>
  )
}
